import React, { Fragment, useContext, useEffect, useState } from "react";
import propTypes from "prop-types";
import { Button, Image } from "react-bootstrap";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import Layout from "components/sales/layout/layout";
import GSTDetails from "components/sales/formSection/GSTDetails/gstDetails";
// import ParkingRules from "components/sales/formSection/parkingRules/parkingRules";
import MaterialHardware from "components/sales/formSection/editPostSaleApt/materialHardwareSection/materialHardware";
import ShippedTo from "components/sales/formSection/shippedTo/shippedTo";
import BilledTo from "components/sales/formSection/billedTo/billedTo";
import ClientDetails from "components/sales/formSection/clientDetails/clientDetails";
import OtherDetailsApt from "components/sales/formSection/otherDetails/otherDetailsApt";
import GateDetails from "components/sales/formSection/gateDetails/gateDetailsApt";
// import DummyAdd from "components/sales/formSection/gateDetails/dummyAdd";
import Commercial from "components/sales/formSection/commercial/commercial";
import Installation from 'components/sales/formSection/commercial/installation';
import Milestone from 'components/sales/formSection/mileStone/mileStone';
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import AgreementContract from "components/sales/formSection/agreementContract/agreementContract";
import Checkbox from "components/sales/Input/checkbox/checkbox";
import Tags from 'components/sales/formSection/materialHardware/tags';
import AdvancePayment from 'components/sales/formSection/materialHardware/advancePayment';
import Increament from 'components/sales/formSection/materialHardware/increament';
import AddPoc from "../../../../components/sales/formSection/addPoc/addPoc";
import B2BRevenue from "../../postSales/B2BRevenue";
import ContractServices from "../../postSales/ContractServices";


const EditSupplyContract = (props) => {
  const {
    history,
    contractSupply,
    contractSupplyData,
    pincodeData,
    locationPinCode,
    postSalesEditSupplyLead,
    documentUploadUrl,
    documentUrlData,
    match,
    getMaterial,
    getMateriaById,
    getBrandById,
    getBrand,
    imageUploadUrl,
    videoUploadUrl,
    supplyNameFun,
    splNameData,
    shipTolocationPinCode,
    shipToPincodeData,
    clientBillingPocData,
    clientBillingAddress,
    getContractRevenue,
    contractRevenueDetails=[],
    getContractService,
    contractCatService=[]
  } = props;
  const { params } = match;
//   console.log(params);
  const postDataInputs = {
    commercial: null,
    gSTDetails: null,
    shippedTo: null,
    // billedTo: null,
    // clientData: null,
    otherDetails: null,
    gateDetails: null,
    // category: [],
    materialHardwares: "No",
    tags:[],
    installation: null,
    pocData: null,
    revenue_nature: null,
    revenue_type: null,
    invoice_type:'Post',
  };
//   const {prerequisiteData} = contractAptData;

  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [showAgreementDetails, setShowAgreementDetails] = useState(false);
  const [agreementLength, setAgreementLength] = useState(null);
  const [isGateDetailsChanged, setIsGateDetailsChanged] = useState(false);
  //   const [prerequisiteData, setPrerequisiteData] = useState(null);
  // const [sameAsBillTo, setSameAsBillTo] = useState(null);
  const [variableServices, setVariableServices] = useState([{id:'', amount:'', qty:'', men_days:0, start_day:'', end_day:''}])
  const [fixedServices, setFixedServices] = useState([{id:'', amount:'', qty:'', men_days:0}])

  const [postApartmentInputs, setPostApartmentData] = useState(postDataInputs);
  const handleCommercial = (val) => {
    setPostApartmentData({ ...postApartmentInputs, commercial: val });
    if (val?.totalContract) {
      setShowAgreementDetails(true);
      setAgreementLength(val?.totalContract);
    }
  };
  const handleGstDetails = (val) => {
    setPostApartmentData({ ...postApartmentInputs, gSTDetails: val });
  };

  const handleGateDtl = (val) => {
    setPostApartmentData({ ...postApartmentInputs, gateDetails: val });
    setIsGateDetailsChanged(true);
  };
  const handleMileStone = (val) => {
    setPostApartmentData({ ...postApartmentInputs, milestone: val });
  };
  // const handleBillTo = (val) => {
  //   setPostApartmentData({ ...postApartmentInputs, billedTo: val });
  // };
  const handleShippedTo = (val) => {
    setPostApartmentData({ ...postApartmentInputs, shippedTo: val });
  };
  // const handleClientData = (val) => {
  //   setPostApartmentData({ ...postApartmentInputs, clientData: val });
  // };
  const handlePocData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, pocData: val });
  };
  const handleOtherDetails = (val) => {
    setPostApartmentData({ ...postApartmentInputs, otherDetails: val });
  };
  const handleGatesData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, categoryInventory: val });
  };
  const handleProductData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, productInventory: val });
  };
  const handleMaterialhardware = (val) => {
    setPostApartmentData({ ...postApartmentInputs, materialHardwares: val });
  };
  const handleagreementDtls = (val) => {
    setPostApartmentData({ ...postApartmentInputs, agreementDtls: val });
  };
  const handleTags = (val) => {
    setPostApartmentData({ ...postApartmentInputs, tagsData: val });
  };
  const handleInstallation = (val) => {
    setPostApartmentData({ ...postApartmentInputs, installation: val });
  };
  const handlePayment = (val) => {
    setPostApartmentData({ ...postApartmentInputs, advPayment: val });
  };
  const handleIncreament = (val) => {
    setPostApartmentData({ ...postApartmentInputs, increamentData: val });
  };  

  const handleModalHide = () => {
    history.push(`${baseUrl}/postSalesListing`);
    setIsModal(false);
  };

  /* useEffect(() => {
    if (
        contractAptData?.prerequisiteData !== undefined &&
        contractAptData?.prerequisiteData !== null
    ) {
      const {
        prerequisiteData
      } = contractAptData;
      setPrerequisiteData(prerequisiteData);
    }
  }, [contractAptData]); */
  
  const handleSubmit = (id) => {
    setIsClicked(true);
    const {
      commercial,
      gSTDetails,
      gateDetails,
      // billedTo,
      shippedTo,
      // clientData,
      // otherDetails,
      categoryInventory,
      productInventory,
      materialHardwares,
      agreementDtls,
      advPayment,
      installation,
      increamentData,
      tagsData,
      milestone,
      pocData,
      revenue_nature,
      revenue_type,
      invoice_type
    } = postApartmentInputs;

    if (
        commercial != null &&
        gSTDetails != null &&
        shippedTo != null &&
        agreementDtls != null &&
        // clientData != null &&
        gateDetails != null &&
        // otherDetails != null &&
        materialHardwares != null
        && pocData != null
      
    ) {
      setIsFiled(false);

      // if(clientData != null && clientData.billing_address !== undefined){
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          // clientData: clientData,
          gateDetails: gateDetails,
          leadStatus:contractSupplyData.leadStatus,
          comm_id:contractSupplyData.comm_id,
          materialHardwares: { ...materialHardwares },
          pocData: pocData
          // ...clientData.billing_address
        }; 
      // }else{
      //   var fObj = {
      //     ...commercial,
      //     ...installation,
      //     ...gSTDetails,
      //     // ...parkingRules,
      //     // ...billedTo,
      //     ...shippedTo,
      //     ...otherDetails,
      //     ...agreementDtls,
      //     clientData: clientData,
      //     gateDetails: gateDetails,
      //     leadStatus:contractAptData.leadStatus,
      //     comm_id:contractAptData.comm_id,
      //     materialHardwares: { ...materialHardwares },
      //     // ...clientData.billing_address
      //   }; 
      // }

      // if (categoryInventory !== null && categoryInventory !== undefined) {
      //   fObj.categoryInventory = [
      //     ...categoryInventory,
      //     ...productInventory?.productData,
      //   ];
      // } else {
      //   fObj.categoryInventory = [];
      // }

      if (categoryInventory !== null && categoryInventory !== undefined && productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
          ...productInventory?.productData,
        ];
      } else if (categoryInventory !== null && categoryInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
        ];
      } else if (productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...productInventory?.productData,
        ];
      } else {
        fObj.categoryInventory = [];
      }


      if (tagsData !== null && tagsData !== undefined) {
        fObj.tags = [
          ...tagsData?.tagData,
        ];
      } else {
        fObj.tags = [];
      }
      if (advPayment !== null && advPayment !== undefined) {
        fObj.payment = [
          ...advPayment?.advData,
        ];
      } else {
        fObj.payment = [];
      }
      if (increamentData !== null && increamentData !== undefined) {
        if (increamentData?.inc?.increament_type) {
          if (increamentData?.inc?.increament_type == 'flat' || increamentData?.inc?.increament_type == 'percentage') {
            if (increamentData?.inc?.duration == undefined || increamentData?.inc?.increament_amount == undefined) {
              return false;
            }
          }
          fObj.increament = [
            increamentData
          ];
        } else {
          fObj.increament = [];
        }
      } else {
        fObj.increament = [];
      }
      if (milestone !== null && milestone != undefined) {
        let totalAmt = parseInt(contractSupplyData?.commercialData?.total_mg_amount);
        let calculatedAmt = 0;
        if (!isNaN(totalAmt)) {
          if (totalAmt > 0) {
            for (let i = 0; i < postApartmentInputs.milestone?.milestone_data.length; i++) {
              if (postApartmentInputs.milestone.milestone_data[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.milestone_data[i].amt);
              }
            }
            for (let i = 0; i < postApartmentInputs.milestone?.date_invoices_data.length; i++) {
              if (postApartmentInputs.milestone.date_invoices_data[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.date_invoices_data[i].amt);
              }
            }
            for (let i = 0; i < postApartmentInputs.milestone?.retention.length; i++) {
              if (postApartmentInputs.milestone.retention[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.retention[i].amt);
              }
            }
            if(calculatedAmt == 0){
              toast.error('Please Fill atleast one milestone');
              return;
            }else if (calculatedAmt > totalAmt) {
              toast.error('Milestone total amount is greater then capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            }else if (calculatedAmt != totalAmt) {
              toast.error('Milestone total amount should be equal to capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            }
            else {
              fObj.milestone=milestone;
            }
          }
        }
      }

      fObj['revenue_nature'] = revenue_nature
      fObj['revenue_type'] = revenue_type
      fObj['invoice_type'] = invoice_type
      if(contractSupplyData?.commercialData !== undefined && contractSupplyData?.commercialData?.revenue_nature === 'Valet'){
        fObj['variable_services'] = variableServices
        fObj['fixed_services'] = fixedServices
      } else{
        fObj['invoice_type'] = 'Pre'
        fObj['revenue_type'] = 'Fixed'
        fObj['revenue_nature'] = 'Self'
      }


      // console.log(fObj); return false;
      (async () => {
        const res = await postSalesEditSupplyLead({ ...fObj, leadId: parseInt(params.manageId), comm_id: parseInt(params.id)});
        if (res) {
          setIsModal(true);
        }
      })();

    } else {
      setIsClicked(false);
      setIsFiled(true);
      const active = document.querySelector('.activeAnkInput');
      if(active){
        active.focus();
      }else{
        alert('Please Upload missed documents or enter valid data!')
      }
    }
  };

  useEffect(() => {

    (async () => {
      await contractSupply(params)
      await getContractRevenue()
      await getContractService('VALET')
    })();
  }, [contractSupply]);

  // console.log(postApartmentData.leadStatus);

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">{localization.save}</Button>
        <Button onClick={() => handleSubmit(params.lead_id)} /* disabled={isClicked} */>
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight} />
        </Button>
      </Fragment>
    );
  };
  function refreshPage() {
    window.location.reload(false);
  }

  const handleRevenueDetails = (key, value) => {
    postApartmentInputs[key] = value
    setPostApartmentData(postApartmentInputs);
  }

  const handleVariableService = (index, key, val) => {
    let list = [...variableServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      variableServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setVariableServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setVariableServices(list)
  }

  const handleFixedService = (index, key, val) => {
    let list = [...fixedServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      fixedServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setFixedServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setFixedServices(list)
  }

  useEffect(() => {
    if(contractSupplyData?.valet_contract_variable_service !== undefined && contractSupplyData?.contractAptData !== null && Object.keys(contractSupplyData?.valet_contract_variable_service).length > 0){
      setVariableServices(contractSupplyData?.valet_contract_variable_service)
    }

    if(contractSupplyData?.valet_contract_fixed_service !== undefined && Object.keys(contractSupplyData?.valet_contract_fixed_service).length > 0){
      setFixedServices(contractSupplyData?.valet_contract_fixed_service)
    }
  }, [contractSupplyData])

  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      className={isFiled ? "requiredFileds" : ""}
      title={localization.editContract}
    >
    { (contractSupplyData !== undefined || contractSupplyData !== null) && (
      <>
        <B2BRevenue
            RevenueData={contractRevenueDetails}
            handleValue={handleRevenueDetails}
            commercialData={contractSupplyData.commercialData}
            isEditable={true}
        />
        <Commercial
            isSupply
            data={contractSupplyData}
            handleValue={handleCommercial}
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            supplyNameFun={supplyNameFun}
            splNameData={splNameData}
            prefilledData={contractSupplyData.postsale_data}
            edit={1}
        />
        <AgreementContract
          handleValue={handleagreementDtls}
          documentUploadUrl={documentUploadUrl}
          agreementLength={agreementLength}
          showDetails={showAgreementDetails}
          isEditContract={true}
          prefilledData={contractSupplyData.postsale_data}
        />
        <GSTDetails
            handleValue={handleGstDetails}
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            prefilledData={contractSupplyData.postsale_data}
        />
      
      <ShippedTo
        handleValue={handleShippedTo}
        locationPinCode={shipTolocationPinCode}
        pincodeData={shipToPincodeData}
        leadData={contractSupplyData.lead_name}
        prefilledData={contractSupplyData.postsale_data}
        // sameAsBillTo={sameAsBillTo}
      />
        <AddPoc
          handleValue={handlePocData}
          prefilledData={contractSupplyData}
        />
      {/* <ClientDetails
        handleValue={handleClientData}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        data={contractAptData}
        clientBillingAddress={clientBillingAddress}
        clientBillingPocData={clientBillingPocData}
        prefilledData={contractAptData.postsale_data}
      /> */}
      
      <GateDetails
        handleValue={handleGateDtl}
        data={contractSupplyData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
        duplicate={false}
        prefilledData={contractSupplyData.postsale_data}
      />
        {contractSupplyData?.commercialData !== undefined && contractSupplyData?.commercialData?.revenue_nature !== 'Valet' &&
          <MaterialHardware
              handleValue={handleMaterialhardware}
              data={contractSupplyData}
              handleGatesData={handleGatesData}
              handleProductData={handleProductData}
              getMaterial={getMaterial}
              getMateriaById={getMateriaById}
              getBrandById={getBrandById}
              getBrand={getBrand}
              prefilledData={contractSupplyData.postsale_data}
              editProduct={true}
              commData={contractSupplyData}
          />
        }
        {contractSupplyData?.commercialData !== undefined && contractSupplyData?.commercialData?.revenue_nature === 'Valet' &&
            <ContractServices
                serviceDetails={contractCatService}
                setVariableServices={setVariableServices}
                variableServices={variableServices}
                handleVariableService={handleVariableService}
                handleFixedService={handleFixedService}
                handleValue={handleRevenueDetails}
                setFixedServices={setFixedServices}
                fixedServices={fixedServices}
                commercialData={contractSupplyData?.commercialData}
            />
        }
        {contractSupplyData?.commercialData !== undefined && contractSupplyData?.commercialData?.revenue_nature !== 'Valet' &&
          <Tags
            handleValue={handleTags}
            data={contractSupplyData}
            prefilledData={contractSupplyData.postsale_data}
          />
        }

        {contractSupplyData?.commercialData !== undefined && contractSupplyData?.commercialData?.revenue_nature !== 'Valet' &&
            <Installation
              handleValue={handleInstallation}
              prefilledData={contractSupplyData.postsale_data}
            />
        }
      
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
      </>
    )}
    </Layout>
  );
};

EditSupplyContract.propTypes = {
  history: propTypes.any,
};

export default EditSupplyContract;
